import axios from 'axios';
import { put, call, takeLeading, delay } from 'redux-saga/effects';
import * as actionTypes from '../actionTypes';
import { api_urls } from '../../utils/api-urls';
import { change_category_status, create_category, delete_category, get_category, update_category } from '../../utils/api-routes';
import Swal from "sweetalert2";

function* getCategory() {
    try {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: true });
        const { data } = yield call(axios.get, `${api_urls + get_category}`);
        console.log("Get Category Saga Response ::: ", data)

        if (data?.status) {
            yield delay(500);
            yield put({ type: actionTypes.SET_CATEGORY, payload: data?.results });
        }
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
    } catch (error) {
        yield put({ type: actionTypes.SET_IS_LOADING, payload: false });
        console.log("Get Category Saga Error ::: ", error)
    }
}

function* createCategory(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const { data } = yield call(axios.post, `${api_urls + create_category}`, payload?.data);
        console.log("Create Category Saga Response ::: ", data)

        if (data?.status) {
            Swal.fire({
                icon: "success",
                text: "Category Created Successfully",
                showConfirmButton: false,
                timer: 2000,
            });
            yield call(payload?.onComplete)
        }

    } catch (error) {
        Swal.fire({
            icon: "error",
            text: "Failed To Create Category",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Create Category Saga Error ::: ", error?.response?.data)
    }
}

function* updateCategory(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const { data } = yield call(axios.post, `${api_urls + update_category}`, payload?.data);
        console.log("Update Category Saga Response ::: ", data)

        if (data?.status) {
            Swal.fire({
                icon: "success",
                text: "Category Updated Successfully",
                showConfirmButton: false,
                timer: 2000,
            });
            yield call(payload?.onComplete)
            yield put({ type: actionTypes.GET_CATEGORY, payload: null })
        }

    } catch (error) {
        console.log("Update Category Saga Error ::: ", error?.response?.data)
    }
}

function* deleteCategory(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const result = yield Swal.fire({
            title: `Are You Sure To Delete`,
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2A9BAA",
            cancelButtonColor: "red",
            confirmButtonText: "Delete",
        })

        console.log("Result ::: ", result)

        if (result.isConfirmed) {
            const { data } = yield call(axios.post, `${api_urls + delete_category}`, payload);
            console.log("Delete Category Saga Response ::: ", data)
            if (data?.status) {
                Swal.fire({
                    icon: "success",
                    text: "Category Deleted Successfully",
                    showConfirmButton: false,
                    timer: 2000,
                });
                yield put({ type: actionTypes.GET_CATEGORY, payload: null })

            }
        }
    } catch (error) {
        Swal.fire({
            icon: "error",
            text: "Failed To Delete Category",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Delete Category Saga Error ::: ", error?.response?.data)
    }
}

function* changeCategoryStatus(action) {
    try {
        const { payload } = action;
        console.log("Payload ::: ", payload)

        const result = yield Swal.fire({
            title: `Are You Sure To Change Status`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#2A9BAA",
            cancelButtonColor: "red",
            confirmButtonText: "Yes",
            cancelButtonText: "No"
        })

        if (result.isConfirmed) {
            const { data } = yield call(axios.post, `${api_urls + change_category_status}`, payload);
            console.log("Change Status Category Saga Response ::: ", data)

            if (data?.status) {
                Swal.fire({
                    icon: "success",
                    text: "Status Change Successfully",
                    showConfirmButton: false,
                    timer: 2000,
                });
                yield put({ type: actionTypes.GET_CATEGORY, payload: null })
            }
        }

    } catch (error) {
        Swal.fire({
            icon: "error",
            text: "Failed To Change Status",
            showConfirmButton: false,
            timer: 2000,
        });
        console.log("Change Status Category Saga Error ::: ", error?.response?.data)
    }
}

export default function* categorySaga() {
    yield takeLeading(actionTypes?.GET_CATEGORY, getCategory);
    yield takeLeading(actionTypes?.CREATE_CATEGORY, createCategory);
    yield takeLeading(actionTypes?.UPDATE_CATEGORY, updateCategory);
    yield takeLeading(actionTypes?.DELETE_CATEGORY, deleteCategory);
    yield takeLeading(actionTypes?.CHANGE_CATEGORY_STATUS, changeCategoryStatus);
}
